import React, { SVGAttributes } from 'react';

export const NoLogoSvg = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='148' height='105' viewBox='0 0 148 105' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g filter='url(#filter0_f_7351_6084)'>
      <ellipse cx='74.0148' cy='89.3074' rx='27.9338' ry='0.362776' fill='#A0A7AB' />
    </g>
    <g filter='url(#filter1_f_7351_6084)'>
      <ellipse cx='74.0148' cy='89.3074' rx='18.5016' ry='0.362776' fill='#A0A7AB' />
    </g>
    <g filter='url(#filter2_f_7351_6084)'>
      <ellipse cx='74.0147' cy='89.3074' rx='9.79495' ry='0.362776' fill='#828A8F' />
    </g>
    <g filter='url(#filter3_d_7351_6084)'>
      <circle cx='74.0148' cy='51.5788' r='37.7287' fill='white' />
      <circle cx='74.0148' cy='51.5788' r='36.2776' stroke='white' strokeWidth='2.90221' />
    </g>
    <defs>
      <filter
        id='filter0_f_7351_6084'
        x='43.1788'
        y='86.0424'
        width='61.6721'
        height='6.53'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1.4511' result='effect1_foregroundBlur_7351_6084' />
      </filter>
      <filter
        id='filter1_f_7351_6084'
        x='52.611'
        y='86.0424'
        width='42.8073'
        height='6.53'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1.4511' result='effect1_foregroundBlur_7351_6084' />
      </filter>
      <filter
        id='filter2_f_7351_6084'
        x='61.3175'
        y='86.0424'
        width='25.3943'
        height='6.53'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1.4511' result='effect1_foregroundBlur_7351_6084' />
      </filter>
      <filter
        id='filter3_d_7351_6084'
        x='30.4817'
        y='8.04568'
        width='87.0664'
        height='87.0664'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='2.90221' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_7351_6084' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_7351_6084' result='shape' />
      </filter>
    </defs>
  </svg>
);
